module.exports = __webpack_public_path__ + "img/frederick-douglass.d52c57cc.png";